import { inject } from '@angular/core';
import { CanActivateChildFn, Router } from '@angular/router';
import { PublicAuthService } from '@app/services/auth/public-auth/public-auth.service';

const UNGUARDED_PUBLIC_ROUTES = new Set([
  '/',
  '/visitor-signup',
  '/privacy-policy',
  '/terms-and-conditions',
  '/news-and-updates',
]);

export function isUnguardedPublicRoute(url: string): boolean {
  const path = url.split(/[?#]/, 1)[0].replace(/\/+$/, '') || '/';

  return UNGUARDED_PUBLIC_ROUTES.has(path) || /^\/news\/[^/]+$/.test(path);
}

export const publicGuard: CanActivateChildFn = (_route, state) => {
  const publicAuthService = inject(PublicAuthService);
  const router = inject(Router);

  if (
    typeof window === 'undefined' ||
    isUnguardedPublicRoute(state.url) ||
    publicAuthService.hasActiveSession()
  ) {
    return true;
  }

  return router.createUrlTree(['/visitor-signup'], {
    queryParams: { redirect: state.url },
  });
};
